import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  collapsed: false,
  onHover: false,
  dashboard: " ",
  otpFlag: false,
  pathname: "",
  completedstages: [],
  currentstage: "",
};

export const projectSlice = createSlice({
  name: "project",
  initialState: initialState,
  reducers: {
    resetaAllProjectDetails: () => initialState,

    setCollapsed(state, action) {
      state.collapsed = action.payload;
    },
    setOnHover(state, action) {
      state.onHover = action.payload;
    },
    setDashboard(state, action) {
      state.dashboard = action.payload;
    },
    setOtpFlag(state, action) {
      state.otpFlag = action.payload;
    },
    setPathName(state, action) {
      state.pathname = action.payload;
    },
    setCompletedStages(state, action) {
      state.completedstages = action.payload;
    },
    setCurrentStage(state, action) {
      state.currentstage = action.payload;
    },
  },
});

export const {
  setCollapsed,
  setOnHover,
  setDashboard,
  setOtpFlag,
  setPathName,
  setCurrentStage,
  setCompletedStages,
} = projectSlice.actions;

export default projectSlice.reducer;